import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type FileNodeType = Node<NodeData, 'custom_file'>;

export const FileNode: React.FC<NodeProps<FileNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const fileId = data.config?.file_id as string;

  let subtitle: string | undefined;
  if (fileId) {
    subtitle = `File: ${fileId}`;
  }

  // Extract connection state from node data for consistency (source-only node)
  const activeConnection = data.activeConnection;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="io"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Config input handle for file_id */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="file_id"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isConfigPort={true}
      />
      {/* Output handle for file data */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="data"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
